export default __webpack_public_path__ + "images/a17a2698aeb06bbcc551fe77d1a5611a-EE_SlideDeckBOOK1024_16.png";